/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import { CustomLink } from '../../../../custom-link';
import { textWithFallback } from '../../helpers';
import './styles.m.css';
import { getPath } from '../../../../../utils';

const FALLBACK_NO_SUB_TEXT = "<p>You don't appear to have a subscription.</p>";
const FALLBACK_SUBSCRIBE_BTN = '<p>Subscribe Now</p>';

const getSubscriptionPageLink = ({ redirectUrl, target, sketchesHost, whiteListedUrlParams }) => {
  if (target !== 'web') return false;
  return getPath({
    sketchesHost,
    relativePath: '/subscription',
    defaultParams: redirectUrl? `redirectUrl=${redirectUrl}`: "",
    injectCustomParams: true,
    whiteListedUrlParams,
    swapDefaultCustomParams : true
  });
};
export const NoActiveSubscriptions = ({
  mode,
  buttonInlineStyles,
  manageSubscriptionsConfig,
  subscriptionConfig,
  redirectUrl,
  target,
  sketchesHost,
  whiteListedUrlParams
}) => {
  const { noSubscription_text } = manageSubscriptionsConfig;
  const { subscribeButton } = subscriptionConfig;
  return (
    <div styleName={`no-subscription content-box ${mode}`}>
      <div
        styleName='no-subscription-text'
        data-test-id='manage-sub-no-sub-text'
        dangerouslySetInnerHTML={{ __html: textWithFallback(noSubscription_text, FALLBACK_NO_SUB_TEXT) }}
      ></div>
      <div styleName='no-subscription-link-parent'>
        <CustomLink
          href={getSubscriptionPageLink({ redirectUrl, target, sketchesHost, whiteListedUrlParams })}
          dangerouslySetInnerHTML={{ __html: textWithFallback(subscribeButton, FALLBACK_SUBSCRIBE_BTN) }}
          data-test-id='manage-sub-subscribe-link'
          style={buttonInlineStyles}
          styleName='no-subscription-link'
        ></CustomLink>
      </div>
    </div>
  );
};
